import React, { useState, useMemo, useEffect, useCallback } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import BottomSheetBase from '../../../../components/comm/BottomSheetBase';
import style from './AgreeConditions.module.css';
import axiosApi from '../../../../api/daonAxios';
import URL from '../../../../constants/url';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';
import { useLocation, useNavigate } from 'react-router-dom';
import ToastPopup from '../../../../components/comm/ToastPopup';
//import ConfirmBox from '../../../../components/box/ConfirmBox';
import { getDpSnsSignin } from '../../../../assets/js/comm'
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';


const AgreeConditions = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    //console.log( " ==================> state :: ", state );

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [sheetOpen, setSheetOpen] = useState(false);
    const [policeInfo, setPoliceInfo] = useState({ title: '', content: '' });
    const [policeList, setPoliceList] = useState([])

    function onDismiss() {
        setOpen(false);
    }

    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);
    const [check4, setCheck4] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const [viewTerm, setViewTerm] = useState(null); 


    useEffect(() => {
        setOpen(false);
    }, []);

  

    const handleCheckAll = (e) => {
        const c = e.target.checked;
        setCheck1(c); setCheck2(c); setCheck3(c); setCheck4(c); setCheckAll(c);
    };
    const toggle = (cur, setCur, others) => {
        const v = !cur;
        setCur(v);
        setCheckAll(v && others.every(Boolean));
    };

    // const handleClickPolicBtn = (code) => {
    //     const p = TERMS[code] || {};
    //     setPoliceInfo({ title: p.title || '', content: p.content || '' });
    //     setSheetOpen(true);
    // };

    // const processedHtml = useMemo(() => {
    //     if (!policeInfo.content) return '';
    //     return policeInfo.content.replace(/<table([\s\S]*?)<\/table>/gi,
    //         '<div class="table-wrapper"><table$1</table></div>');
    // }, [policeInfo.content]);


    const handleOnAgreeCheck = () => {
        if (check1 && check2 && check3 && check4) {
            const allTrmsAgreDt = Math.floor(Date.now() / 1000);

            if(!state.provider || state.provider === 'password') {
                navigate(URL.SIGN_UP, { state: { ...state, allTrmsAgreDt: allTrmsAgreDt }});
            } else {
                snsSignUp(allTrmsAgreDt);
            }


        } else {
            setToastMessage('서비스 이용을 위해 약관에 모두 동의해야 합니다.');
            setToast(true);
        }
    };


    useEffect(() => {
        //약관 목록 호출
        const getData = async () => {

            const url = `/signup/retrieveHospitalPolicyIdList`;

            await axiosApi.post(url, ["A","B","C","D"])
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setPoliceList(res.data.result.result);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("===========> 이용약관 호출 실패  : ", err);
            })
        }

        getData();

    },[]);

    const handleClickPolicBtn = useCallback((stplatPolicySeCd) => {
        const selectPolice = policeList.find((item) => item.stplatPolicySeCd === stplatPolicySeCd) ?? {};

        const isEmpty = Object.keys(selectPolice).length === 0

        if(!isEmpty) {
            setPoliceInfo({title : selectPolice.stplatPolicySj, content : selectPolice.stplatPolicyCn});
        } else {
            setPoliceInfo({title : '', content : ''});
        }
        // setOpen(true);

        setSheetOpen(true);
    },[policeList])



    ////////////////////////////////// password 를 제외한 sns는 여기서 회원 가입을 시킴///////////////////////////////////////

    const [ signUsrInfo, setSignUsrInfo ] = useState({});

    const snsSignUp = useCallback(async (allTrmsAgreDt) => {

        // SIGN_UP_NAVER("12", "sign up - naver"),
        // SIGN_UP_KAKAO("13", "sign up - kakao"),
        // SIGN_UP_GOOGLE("14", "sign up - google"),
        // SIGN_UP_APPLE("15", "sign up - apple"),

        const usrSeCd = state.provider === 'naver' ? "12" : state.provider === 'kakao' ? "13" :
            state.provider === 'google' ? "14" : state.provider === 'apple' ? "15" : "";

        const snsSignObj = {
            sns : state.provider,
            [(['naver', 'kakao'].includes(state.provider) ? 'accessToken' : 'idToken')]: state.accessToken,
            accessToken: state.accessToken,
            displayName: state.usrNm,
            phoneNumber: state.mblNo,
            email: state.emailAdres,
            birth: state.brthdy,
            gender: state.gendr,
            staff: false,
            // pushToken: "string", //앱에서만
            cid: state.encptCidVal,

        }

        const signRes = await getDpSnsSignin(snsSignObj);

        if (signRes?.accessToken !== undefined && signRes?.accessToken !== "") {

            const jToken = signRes?.accessToken;
            const refreshToken = signRes?.refreshToken;
            const requestLoginUrl = "/signup/saveUser"

            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                }
            }
            const signupReq = {
                ...state, crtfcTknVal: refreshToken, usrSeCd : usrSeCd, statCd: "1", allTrmsAgreDt: allTrmsAgreDt,
            }

            // IITP  서버 저장로직 완료 후 .. =>  MEMBERSHIP_COMPLETE  넘겨준다.
            axiosApi.post(requestLoginUrl, signupReq, requestOptions)
                .then((res) => {
                    console.log( "=============> iitpUser : ", res );
                    if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                        const iitpUser = res.data.result.iitpUser;
                        sessionStorage.setItem('loginUser', JSON.stringify(iitpUser))
                        localStorage.setItem('jToken', jToken);
                        setSignUsrInfo( { ...iitpUser });
                        // 일반 가입은 SignUp 화면을 거쳐 완료화면으로 간다. SNS 는 이 화면이 마지막이라
                        // 여기서 바로 완료화면으로 보낸다.
                        localStorage.setItem("IITP_CRTFC_TKN", iitpUser?.crtfcTknVal || '');
                        navigate(URL.MEMBERSHIP_COMPLETE, { state: { ...iitpUser } });
                    } else if (Number(res.data.resultCode) === Number(CODE.RCV_FAILURE)) {
                        // failure // 실패시 ..  두종류가 있음.
                        // 1.IITP  계정이 존재하는 경우(이 경우 나올일이 없지만.. 데이터가 꼬인경우.)
                        // 2.IITP  저장실패
                        const isExistUserAt = res.data.result?.isExistAt; // true : 기생성 | false : 저장실패
                        if(isExistUserAt) {
                            console.log( " ================> RCV_FAILURE : ", res );
                            setToastMessage(MSG.ERR_DUPUSR);
                            setToast(true);
                        } else {
                            console.log( " ================> RCV_FAILURE : ", res );
                            setToastMessage(MSG.PRCS_FAILSAVE);
                            setToast(true);
                        }
                    } else { // 900 .. 입력 validation 에러
                        console.log(" =========> RCV_ERROR_VALIDATION : ", res );
                        setToastMessage(MSG.ERR_INPUTVALID);
                        setToast(true);
                    }
                })
                .catch((err) => {
                    console.log( " ================> RCV_ERROR_SERVER ", err);
                })
        } else {
            alert(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
        }

    },[state]);

    return (
        <>
            <HeadSub title="약관 동의" />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="30">
                    <div className="animation-2">
                        <div className={style['top-box']}>
                            <div className={style['main-txt-box']}>
                                <p>안전하고 편리한 홈케어 서비스를 위해 <b>WellBe 약관</b>을 확인하시고</p>
                                <p><b>동의</b>해주세요</p>
                            </div>
                            <div className={style['sub-txt-box']}>
                                <span>여러분의 개인정보와 서비스 이용 권리를 <br />잘 지켜드리겠습니다</span>
                            </div>
                        </div>

                        <div className={style['mid-box']}>
                            <div className={style['all-agree-box']}>
                                <div className="chkbox-custom" data-chkbox="basic">
                                    <input type="checkbox" id="all-chk" checked={checkAll} onChange={handleCheckAll} />
                                    <label htmlFor="all-chk">
                                        <div className={style['txt-box']}>
                                            <p>모두 동의합니다.</p>
                                            <span>서비스 이용을 위해 아래 약관에 모두 동의합니다</span>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div className={style['require-agree-box']}>
                                <ul>
                                    <li>
                                        <div className="chkbox-custom" data-chkbox="basic">
                                            <input type="checkbox" id="require-chk1" checked={check1} onChange={() => toggle(check1, setCheck1, [check2, check3, check4])} />
                                            <label htmlFor="require-chk1"><div className={style['txt-box']}><b>[필수]</b> <p>서비스 이용약관</p></div></label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('A')}><span>보기</span></button>
                                    </li>
                                    <li>
                                        <div className="chkbox-custom" data-chkbox="basic">
                                            <input type="checkbox" id="require-chk2" checked={check2} onChange={() => toggle(check2, setCheck2, [check1, check3, check4])} />
                                            <label htmlFor="require-chk2"><div className={style['txt-box']}><b>[필수]</b> <p>개인정보 수집 및 이용동의</p></div></label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('B')}><span>보기</span></button>
                                    </li>
                                    <li>
                                        <div className="chkbox-custom" data-chkbox="basic">
                                            <input type="checkbox" id="require-chk3" checked={check3} onChange={() => toggle(check3, setCheck3, [check1, check2, check4])} />
                                            <label htmlFor="require-chk3"><div className={style['txt-box']}><b>[필수]</b> <p>개인정보 처리 방침</p></div></label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('C')}><span>보기</span></button>
                                    </li>
                                    <li>
                                        <div className="chkbox-custom" data-chkbox="basic">
                                            <input type="checkbox" id="require-chk4" checked={check4} onChange={() => toggle(check4, setCheck4, [check1, check2, check3])} />
                                            <label htmlFor="require-chk4"><div className={style['txt-box']}><b>[필수]</b> <p>민감정보 수집 및 이용 동의</p></div></label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('D')}><span>보기</span></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                    onClick={handleOnAgreeCheck} disabled={!(check1 && check2 && check3 && check4)}>
                                    <span>다음</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 약관 바텀시트 — BottomSheetBase 사용 */}
                    <BottomSheetBase open={sheetOpen} onDismiss={() => setSheetOpen(false)} maxHeight="85vh">
                        {/* <div className={style['police-content']}>
                            <strong className={style['police-title']}>{policeInfo.title || '약관 동의'}</strong>
                            <div className={style['police-body']}>{policeInfo.content}</div>
                        </div> */}
                        <AgreeConditionsBox onClose={onDismiss} title={policeInfo.title} children={policeInfo.content}/>
                    </BottomSheetBase>


                    {toast && <ToastPopup setToast={setToast} message={toastMessage} position="center" />}
                </div>
            </div>
        </>
    );
};

export default AgreeConditions;
